import { organisationApi } from '../../apis';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ORGANISATION_FEATURE } from './helper';

export const useQueryFeatures = (organisationId: number | undefined) => {
  return useQuery({
    refetchOnMount: false,
    queryKey: ['features', organisationId],
    queryFn: () =>
      organisationApi.findAllOrganisationFeatures({
        organisationId,
      }),
    enabled: !!organisationId,
  });
};

export const useToggleFeature = (organisationId: number | undefined, currentOrganisationId: number | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ feature, isFeatureActive }: { feature: ORGANISATION_FEATURE; isFeatureActive: boolean }) => {
      if (!organisationId) {
        return;
      }
      if (!isFeatureActive) {
        await organisationApi.addFeature({
          apiFeature: {
            organisationId,
            feature,
          },
        });
      } else {
        await organisationApi.deleteFeatureByNameAndOrgId({
          organisationId,
          featureName: feature,
        });
      }
    },
    onSuccess: async () => {
      if (!organisationId) {
        return;
      }
      await queryClient.invalidateQueries({ queryKey: ['features', organisationId] });
      if (organisationId === currentOrganisationId) {
        await queryClient.invalidateQueries({ queryKey: ['me'] });
      }
    },
  });
};
